module.exports = __webpack_public_path__ + "img/lordsandladies.98623928.jpg";